import $axios from "../../api";

// MODULE NAME
const PREFIX = "website/email-queue";

const state = () => ({
  isLoading: false,
  isErrors: "",
  page: 1,
  isSuccess: false,
  list: null,
  detail: null,
  productDetail: {},
  statusProductDetail: null,
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
  SET_PRODUCT_DETAIL(state, payload) {
    state.productDetail = payload;
  },
  SET_STATUS_PRODUCT_DETAIL(state, payload) {
    state.statusProductDetail = payload;
  },
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX}/list?page=${state.page}&view=${rootState.Main.view
          }${payload || ""}`
        )
        .then((res) => {
          commit("SET_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  resendEmail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/resend`, { id: payload })
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getProductDetailWebsite({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`https://api.naturalfarm.id/api/product/${payload}?size_file=lg`)
        .then((res) => {
          commit("SET_PRODUCT_DETAIL", res.data.data);
          commit("SET_IS_SUCCESS", true);
          commit("SET_STATUS_PRODUCT_DETAIL", res.data.status);
          commit("SET_LOADING", false);
          resolve(res.data.data);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_IS_SUCCESS", false);
          commit("ASSIGN_ERRORS", error.response.data.errors);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};

